module.exports = __webpack_public_path__ + "img/38.e12c5bac.jpg";